<template>
  <v-content>
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>
  </v-content>
</template>

<script>
export default {
  name: 'Container',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.container
  padding: 2em
  padding-bottom: 9em
</style>
